import { useEffect, useState } from 'react';

/**
 * Подписка на медиазапрос (ТЗ 0070).
 *
 * ⚠️ Именно `matchMedia`, а НЕ `useWindowSize`: тот стреляет на каждом кадре
 * изменения размера, и раскладка карты пересчитывалась бы шестьдесят раз в
 * секунду при перетаскивании края окна. Здесь событие приходит один раз — в
 * момент пересечения границы.
 *
 * ⚠️ В jsdom `matchMedia` не реализован вовсе, а если его подменить — по
 * умолчанию отвечает `matches: false`. Значит в тестах экран сходится к
 * мобильной ветке, и тесту канваса подмену придётся делать самому.
 */
export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const list = window.matchMedia(query);
    const onChange = (event: MediaQueryListEvent) => setMatches(event.matches);
    setMatches(list.matches);
    // Safari до 14 знает только `addListener`. Проверка дешевле, чем отчёт
    // «на айфоне карта всегда мобильная».
    if (list.addEventListener) list.addEventListener('change', onChange);
    else list.addListener(onChange);
    return () => {
      if (list.removeEventListener) list.removeEventListener('change', onChange);
      else list.removeListener(onChange);
    };
  }, [query]);

  return matches;
};
